export const countries = () => {
  return [
    {
      short: `DK`,
      name: `Denmark`,
      phone: `+45`
    },
    {
      short: `NO`,
      name: `Norway`,
      phone: `+47`
    },
    {
      short: `SE`,
      name: `Sweden`,
      phone: `+46`
    },
    {
      short: `DE`,
      name: `Germany`,
      phone: `+49`
    },
    {
      short: `NL`,
      name: `Netherlands`,
      phone: `+31`
    },
    {
      short: `GB`,
      name: `United Kingdom`,
      phone: `+44`
    },
    {
      short: `FI`,
      name: `Finland`,
      phone: `+358`
    },
    {
      short: `AI`,
      name: `Austria`,
      phone: `+43`
    },
    {
      short: `FR`,
      name: `France`,
      phone: `+33`
    },
    {
      short: `BE`,
      name: `Belgium`,
      phone: `+32`
    },
    {
      short: `PL`,
      name: `Poland`,
      phone: `+48`
    },
    {
      short: `IE`,
      name: `Ireland`,
      phone: `+353`
    },
    {
      short: `AF`,
      name: `Afghanistan`,
      phone: `+93`
    },
    {
      short: `AL`,
      name: `Albania`,
      phone: `+355`
    },
    {
      short: `DZ`,
      name: `Algeria`,
      phone: `+213`
    },
    {
      short: `AS`,
      name: `American Samoa`,
      phone: `+1`
    },
    {
      short: `AD`,
      name: `Andorra`,
      phone: `+376`
    },
    {
      short: `AO`,
      name: `Angola`,
      phone: `+244`
    },
    {
      short: `AI`,
      name: `Anguilla`,
      phone: `+1`
    },
    {
      short: `AG`,
      name: `Antigua`,
      phone: `+1`
    },
    {
      short: `AR`,
      name: `Argentina`,
      phone: `+54`
    },
    {
      short: `AM`,
      name: `Armenia`,
      phone: `+374`
    },
    {
      short: `AW`,
      name: `Aruba`,
      phone: `+297`
    },
    {
      short: `AU`,
      name: `Australia`,
      phone: `+61`
    },
    {
      short: `AZ`,
      name: `Azerbaijan`,
      phone: `+994`
    },
    {
      short: `BH`,
      name: `Bahrain`,
      phone: `+973`
    },
    {
      short: `BD`,
      name: `Bangladesh`,
      phone: `+880`
    },
    {
      short: `BB`,
      name: `Barbados`,
      phone: `+1`
    },
    {
      short: `BY`,
      name: `Belarus`,
      phone: `+375`
    },
    {
      short: `BZ`,
      name: `Belize`,
      phone: `+501`
    },
    {
      short: `BJ`,
      name: `Benin`,
      phone: `+229`
    },
    {
      short: `BM`,
      name: `Bermuda`,
      phone: `+1`
    },
    {
      short: `BT`,
      name: `Bhutan`,
      phone: `+975`
    },
    {
      short: `BO`,
      name: `Bolivia`,
      phone: `+591`
    },
    {
      short: `BA`,
      name: `Bosnia and Herzegovina`,
      phone: `+387`
    },
    {
      short: `BW`,
      name: `Botswana`,
      phone: `+267`
    },
    {
      short: `BR`,
      name: `Brazil`,
      phone: `+55`
    },
    {
      short: `IO`,
      name: `British Indian Ocean Territory`,
      phone: `+246`
    },
    {
      short: `VG`,
      name: `British Virgin Islands`,
      phone: `+1`
    },
    {
      short: `BN`,
      name: `Brunei`,
      phone: `+673`
    },
    {
      short: `BG`,
      name: `Bulgaria`,
      phone: `+359`
    },
    {
      short: `BF`,
      name: `Burkina Faso`,
      phone: `+226`
    },
    {
      short: `MM`,
      name: `Burma Myanmar`,
      phone: `+95`
    },
    {
      short: `BI`,
      name: `Burundi`,
      phone: `+257`
    },
    {
      short: `KH`,
      name: `Cambodia`,
      phone: `+855`
    },
    {
      short: `CM`,
      name: `Cameroon`,
      phone: `+237`
    },
    {
      short: `CA`,
      name: `Canada`,
      phone: `+1`
    },
    {
      short: `CV`,
      name: `Cape Verde`,
      phone: `+238`
    },
    {
      short: `KY`,
      name: `Cayman Islands`,
      phone: `+1`
    },
    {
      short: `CF`,
      name: `Central African Republic`,
      phone: `+236`
    },
    {
      short: `ID`,
      name: `Chad`,
      phone: `+235`
    },
    {
      short: `CL`,
      name: `Chile`,
      phone: `+56`
    },
    {
      short: `CN`,
      name: `China`,
      phone: `+86`
    },
    {
      short: `CO`,
      name: `Colombia`,
      phone: `+57`
    },
    {
      short: `KM`,
      name: `Comoros`,
      phone: `+269`
    },
    {
      short: `CK`,
      name: `Cook Islands`,
      phone: `+682`
    },
    {
      short: `CR`,
      name: `Costa Rica`,
      phone: `+506`
    },
    {
      short: `CI`,
      name: 'Côte d`Ivoire',
      phone: `+225`
    },
    {
      short: `HR`,
      name: `Croatia`,
      phone: `+385`
    },
    {
      short: `CU`,
      name: `Cuba`,
      phone: `+53`
    },
    {
      short: `CY`,
      name: `Cyprus`,
      phone: `+357`
    },
    {
      short: `CZ`,
      name: `Czech Republic`,
      phone: `+420`
    },
    {
      short: `CD`,
      name: `Democratic Republic of Congo`,
      phone: `+243`
    },
    {
      short: `DJ`,
      name: `Djibouti`,
      phone: `+253`
    },
    {
      short: `DM`,
      name: `Dominica`,
      phone: `+1`
    },
    {
      short: `DO`,
      name: `Dominican Republic`,
      phone: `+1`
    },
    {
      short: `EC`,
      name: `Ecuador`,
      phone: `+593`
    },
    {
      short: `EG`,
      name: `Egypt`,
      phone: `+20`
    },
    {
      short: `SV`,
      name: `El Salvador`,
      phone: `+503`
    },
    {
      short: `GQ`,
      name: `Equatorial Guinea`,
      phone: `+240`
    },
    {
      short: `ER`,
      name: `Eritrea`,
      phone: `+291`
    },
    {
      short: `EE`,
      name: `Estonia`,
      phone: `+372`
    },
    {
      short: `ET`,
      name: `Ethiopia`,
      phone: `+251`
    },
    {
      short: `FK`,
      name: `Falkland Islands`,
      phone: `+500`
    },
    {
      short: `FO`,
      name: `Faroe Islands`,
      phone: `+298`
    },
    {
      short: `FM`,
      name: `Federated States of Micronesia`,
      phone: `+691`
    },
    {
      short: `FJ`,
      name: `Fiji`,
      phone: `+679`
    },
    {
      short: `GF`,
      name: `French Guiana`,
      phone: `+594`
    },
    {
      short: `PF`,
      name: `French Polynesia`,
      phone: `+689`
    },
    {
      short: `GA`,
      name: `Gabon`,
      phone: `+241`
    },
    {
      short: `GE`,
      name: `Georgia`,
      phone: `+995`
    },
    {
      short: `GH`,
      name: `Ghana`,
      phone: `+233`
    },
    {
      short: `GI`,
      name: `Gibraltar`,
      phone: `+350`
    },
    {
      short: `GR`,
      name: `Greece`,
      phone: `+30`
    },
    {
      short: `GL`,
      name: `Greenland`,
      phone: `+299`
    },
    {
      short: `GD`,
      name: `Grenada`,
      phone: `+1`
    },
    {
      short: `GP`,
      name: `Guadeloupe`,
      phone: `+590`
    },
    {
      short: `GU`,
      name: `Guam`,
      phone: `+1`
    },
    {
      short: `GT`,
      name: `Guatemala`,
      phone: `+502`
    },
    {
      short: `GN`,
      name: `Guinea`,
      phone: `+224`
    },
    {
      short: `GW`,
      name: `Guinea-Bissau`,
      phone: `+245`
    },
    {
      short: `GY`,
      name: `Guyana`,
      phone: `+592`
    },
    {
      short: `HT`,
      name: `Haiti`,
      phone: `+509`
    },
    {
      short: `HN`,
      name: `Honduras`,
      phone: `+504`
    },
    {
      short: `HK`,
      name: `Hong Kong`,
      phone: `+852`
    },
    {
      short: `HU`,
      name: `Hungary`,
      phone: `+36`
    },
    {
      short: `IS`,
      name: `Iceland`,
      phone: `+354`
    },
    {
      short: `IN`,
      name: `India`,
      phone: `+91`
    },
    {
      short: `ID`,
      name: `Indonesia`,
      phone: `+62`
    },
    {
      short: `IR`,
      name: `Iran`,
      phone: `+98`
    },
    {
      short: `IQ`,
      name: `Iraq`,
      phone: `+964`
    },
    {
      short: `IL`,
      name: `Israel`,
      phone: `+972`
    },
    {
      short: `IT`,
      name: `Italy`,
      phone: `+39`
    },
    {
      short: `JM`,
      name: `Jamaica`,
      phone: `+1`
    },
    {
      short: `JP`,
      name: `Japan`,
      phone: `+81`
    },
    {
      short: `JO`,
      name: `Jordan`,
      phone: `+962`
    },
    {
      short: `KZ`,
      name: `Kazakhstan`,
      phone: `+7`
    },
    {
      short: `KE`,
      name: `Kenya`,
      phone: `+254`
    },
    {
      short: `KI`,
      name: `Kiribati`,
      phone: `+686`
    },
    {
      short: `XK`,
      name: `Kosovo`,
      phone: `+381`
    },
    {
      short: `KW`,
      name: `Kuwait`,
      phone: `+965`
    },
    {
      short: `KG`,
      name: `Kyrgyzstan`,
      phone: `+996`
    },
    {
      short: `LA`,
      name: `Laos`,
      phone: `+856`
    },
    {
      short: `LV`,
      name: `Latvia`,
      phone: `+371`
    },
    {
      short: `LB`,
      name: `Lebanon`,
      phone: `+961`
    },
    {
      short: `LS`,
      name: `Lesotho`,
      phone: `+266`
    },
    {
      short: `LR`,
      name: `Liberia`,
      phone: `+231`
    },
    {
      short: `LY`,
      name: `Libya`,
      phone: `+218`
    },
    {
      short: `LI`,
      name: `Liechtenstein`,
      phone: `+423`
    },
    {
      short: `LT`,
      name: `Lithuania`,
      phone: `+370`
    },
    {
      short: `LU`,
      name: `Luxembourg`,
      phone: `+352`
    },
    {
      short: `MO`,
      name: `Macau`,
      phone: `+853`
    },
    {
      short: `MK`,
      name: `Macedonia`,
      phone: `+389`
    },
    {
      short: `MG`,
      name: `Madagascar`,
      phone: `+261`
    },
    {
      short: `MW`,
      name: `Malawi`,
      phone: `+265`
    },
    {
      short: `MY`,
      name: `Malaysia`,
      phone: `+60`
    },
    {
      short: `MV`,
      name: `Maldives`,
      phone: `+960`
    },
    {
      short: `ML`,
      name: `Mali`,
      phone: `+223`
    },
    {
      short: `MT`,
      name: `Malta`,
      phone: `+356`
    },
    {
      short: `MH`,
      name: `Marshall Islands`,
      phone: `+692`
    },
    {
      short: `MQ`,
      name: `Martinique`,
      phone: `+596`
    },
    {
      short: `MR`,
      name: `Mauritania`,
      phone: `+222`
    },
    {
      short: `MU`,
      name: `Mauritius`,
      phone: `+230`
    },
    {
      short: `YT`,
      name: `Mayotte`,
      phone: `+262`
    },
    {
      short: `MX`,
      name: `Mexico`,
      phone: `+52`
    },
    {
      short: `MD`,
      name: `Moldova`,
      phone: `+373`
    },
    {
      short: `MC`,
      name: `Monaco`,
      phone: `+377`
    },
    {
      short: `MN`,
      name: `Mongolia`,
      phone: `+976`
    },
    {
      short: `ME`,
      name: `Montenegro`,
      phone: `+382`
    },
    {
      short: `MS`,
      name: `Montserrat`,
      phone: `+1`
    },
    {
      short: `MA`,
      name: `Morocco`,
      phone: `+212`
    },
    {
      short: `MZ`,
      name: `Mozambique`,
      phone: `+258`
    },
    {
      short: `NA`,
      name: `Namibia`,
      phone: `+264`
    },
    {
      short: `NR`,
      name: `Nauru`,
      phone: `+674`
    },
    {
      short: `NP`,
      name: `Nepal`,
      phone: `+977`
    },
    {
      short: `AN`,
      name: `Netherlands Antilles`,
      phone: `+599`
    },
    {
      short: `NC`,
      name: `New Caledonia`,
      phone: `+687`
    },
    {
      short: `NZ`,
      name: `New Zealand`,
      phone: `+64`
    },
    {
      short: `NI`,
      name: `Nicaragua`,
      phone: `+505`
    },
    {
      short: `NE`,
      name: `Niger`,
      phone: `+227`
    },
    {
      short: `NG`,
      name: `Nigeria`,
      phone: `+234`
    },
    {
      short: `NU`,
      name: `Niue`,
      phone: `+683`
    },
    {
      short: `NF`,
      name: `Norfolk Island`,
      phone: `+672`
    },
    {
      short: `KP`,
      name: `North Korea`,
      phone: `+850`
    },
    {
      short: `MP`,
      name: `Northern Mariana Islands`,
      phone: `+1`
    },
    {
      short: `OM`,
      name: `Oman`,
      phone: `+968`
    },
    {
      short: `PK`,
      name: `Pakistan`,
      phone: `+92`
    },
    {
      short: `PW`,
      name: `Palau`,
      phone: `+680`
    },
    {
      short: `PS`,
      name: `Palestine`,
      phone: `+970`
    },
    {
      short: `PA`,
      name: `Panama`,
      phone: `+507`
    },
    {
      short: `PG`,
      name: `Papua New Guinea`,
      phone: `+675`
    },
    {
      short: `PY`,
      name: `Paraguay`,
      phone: `+595`
    },
    {
      short: `PE`,
      name: `Peru`,
      phone: `+51`
    },
    {
      short: `PH`,
      name: `Philippines`,
      phone: `+63`
    },
    {
      short: `PT`,
      name: `Portugal`,
      phone: `+351`
    },
    {
      short: `PR`,
      name: `Puerto Rico`,
      phone: `+1`
    },
    {
      short: `QA`,
      name: `Qatar`,
      phone: `+974`
    },
    {
      short: `CG`,
      name: `Republic of the Congo`,
      phone: `+242`
    },
    {
      short: `RE`,
      name: `Réunion`,
      phone: `+262`
    },
    {
      short: `RO`,
      name: `Romania`,
      phone: `+40`
    },
    {
      short: `RU`,
      name: `Russia`,
      phone: `+7`
    },
    {
      short: `RW`,
      name: `Rwanda`,
      phone: `+250`
    },
    {
      short: `BL`,
      name: `Saint Barthélemy`,
      phone: `+590`
    },
    {
      short: `SH`,
      name: `Saint Helena`,
      phone: `+290`
    },
    {
      short: `KN`,
      name: `Saint Kitts and Nevis`,
      phone: `+1`
    },
    {
      short: `MF`,
      name: `Saint Martin`,
      phone: `+590`
    },
    {
      short: `PM`,
      name: `Saint Pierre and Miquelon`,
      phone: `+508`
    },
    {
      short: `VC`,
      name: `Saint Vincent and the Grenadines`,
      phone: `+1`
    },
    {
      short: `WS`,
      name: `Samoa`,
      phone: `+685`
    },
    {
      short: `SM`,
      name: `San Marino`,
      phone: `+378`
    },
    {
      short: `ST`,
      name: `São Tomé and Príncipe`,
      phone: `+239`
    },
    {
      short: `SA`,
      name: `Saudi Arabia`,
      phone: `+966`
    },
    {
      short: `SN`,
      name: `Senegal`,
      phone: `+221`
    },
    {
      short: `RS`,
      name: `Serbia`,
      phone: `+381`
    },
    {
      short: `SC`,
      name: `Seychelles`,
      phone: `+248`
    },
    {
      short: `SL`,
      name: `Sierra Leone`,
      phone: `+232`
    },
    {
      short: `SG`,
      name: `Singapore`,
      phone: `+65`
    },
    {
      short: `SK`,
      name: `Slovakia`,
      phone: `+421`
    },
    {
      short: `SI`,
      name: `Slovenia`,
      phone: `+386`
    },
    {
      short: `SB`,
      name: `Solomon Islands`,
      phone: `+677`
    },
    {
      short: `SO`,
      name: `Somalia`,
      phone: `+252`
    },
    {
      short: `ZA`,
      name: `South Africa`,
      phone: `+27`
    },
    {
      short: `KR`,
      name: `South Korea`,
      phone: `+82`
    },
    {
      short: `ES`,
      name: `Spain`,
      phone: `+34`
    },
    {
      short: `LK`,
      name: `Sri Lanka`,
      phone: `+94`
    },
    {
      short: `LC`,
      name: `St. Lucia`,
      phone: `+1`
    },
    {
      short: `SD`,
      name: `Sudan`,
      phone: `+249`
    },
    {
      short: `SR`,
      name: `Suriname`,
      phone: `+597`
    },
    {
      short: `SZ`,
      name: `Swaziland`,
      phone: `+268`
    },
    {
      short: `CH`,
      name: `Switzerland`,
      phone: `+41`
    },
    {
      short: `SY`,
      name: `Syria`,
      phone: `+963`
    },
    {
      short: `TW`,
      name: `Taiwan`,
      phone: `+886`
    },
    {
      short: `TJ`,
      name: `Tajikistan`,
      phone: `+992`
    },
    {
      short: `TZ`,
      name: `Tanzania`,
      phone: `+255`
    },
    {
      short: `TH`,
      name: `Thailand`,
      phone: `+66`
    },
    {
      short: `BS`,
      name: `The Bahamas`,
      phone: `+1`
    },
    {
      short: `GM`,
      name: `The Gambia`,
      phone: `+220`
    },
    {
      short: `TL`,
      name: `Timor-Leste`,
      phone: `+670`
    },
    {
      short: `TG`,
      name: `Togo`,
      phone: `+228`
    },
    {
      short: `TK`,
      name: `Tokelau`,
      phone: `+690`
    },
    {
      short: `TO`,
      name: `Tonga`,
      phone: `+676`
    },
    {
      short: `TT`,
      name: `Trinidad and Tobago`,
      phone: `+1`
    },
    {
      short: `TN`,
      name: `Tunisia`,
      phone: `+216`
    },
    {
      short: `TR`,
      name: `Turkey`,
      phone: `+90`
    },
    {
      short: `TM`,
      name: `Turkmenistan`,
      phone: `+993`
    },
    {
      short: `TC`,
      name: `Turks and Caicos Islands`,
      phone: `+1`
    },
    {
      short: `TV`,
      name: `Tuvalu`,
      phone: `+688`
    },
    {
      short: `UG`,
      name: `Uganda`,
      phone: `+256`
    },
    {
      short: `UA`,
      name: `Ukraine`,
      phone: `+380`
    },
    {
      short: `AE`,
      name: `United Arab Emirates`,
      phone: `+971`
    },
    {
      short: `US`,
      name: `United States`,
      phone: `+1`
    },
    {
      short: `UY`,
      name: `Uruguay`,
      phone: `+598`
    },
    {
      short: `VI`,
      name: `US Virgin Islands`,
      phone: `+1`
    },
    {
      short: `UZ`,
      name: `Uzbekistan`,
      phone: `+998`
    },
    {
      short: `VU`,
      name: `Vanuatu`,
      phone: `+678`
    },
    {
      short: `VA`,
      name: `Vatican City`,
      phone: `+39`
    },
    {
      short: `VE`,
      name: `Venezuela`,
      phone: `+58`
    },
    {
      short: `VN`,
      name: `Vietnam`,
      phone: `+84`
    },
    {
      short: `WF`,
      name: `Wallis and Futuna`,
      phone: `+681`
    },
    {
      short: `YE`,
      name: `Yemen`,
      phone: `+967`
    },
    {
      short: `ZM`,
      name: `Zambia`,
      phone: `+260`
    },
    {
      short: `ZW`,
      name: `Zimbabwe`,
      phone: `+263`
    }
  ]
}
